<template>
  <div>
      <div id="box">
        <v-row >
          <v-col cols="12" class="pd-bottom-0">
            <v-row justify="center" align="center">
              <v-col>
                <div id="title" :style="{'color':theme}">                  
                  {{title}}
                </div>
              </v-col>
              <!-- <v-col justify="center" align="center" >
                <div style="padding:10px 10px 0px 10px;">
                  <v-select
                    v-model="selectedFilter"
                    item-value="id" 
                    item-text="name"
                    :items="filters"
                    label="Filter"
                    dense
                    hide-details
                    outlined
                    @change="selectedChangeHandler"
                  ></v-select>
                </div>
              </v-col> -->
            </v-row>  
            <v-divider ></v-divider>
          </v-col>
        </v-row>
        <v-row class="mg-top-0">
            <v-col cols="12" class="pd-top-0">
                <v-container class="pd-top-0">                    
                    <v-simple-table fixed-header>
                        <template v-slot:default>
                        <thead>
                            <tr>
                              <th style="border:none !important;" class="text-center">
                                  Name
                              </th>
                              <th style="border:none !important;" class="text-center">
                                  Activation
                              </th>
                              <th style="border:none !important;" class="text-center">
                                  Pairing
                              </th>
                              <th style="border:none !important;" class="text-center">
                                  CO-Creating
                              </th>
                              <th style="border:none !important;" class="text-center">
                                  Completion
                              </th>
                              <th style="border:none !important;" class="text-center">
                                  Overall Average
                              </th>                   
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                            v-for="(item, index) in top5Rows"
                            :key="index" 
                            >
                              <td style="line-height:35px;padding:0px 0px;font-weight:300;" align="center">
                                <div class="left-div-border" :style="{ 'border-left-color': theme }"></div>
                                {{item.name}}
                              </td>
                              <td style="line-height:35px;padding:0px 0px;font-weight:300;" align="center">
                                {{item.ACTIVATION}}
                              </td>
                              <td style="line-height:35px;padding:0px 0px;font-weight:300;" align="center">
                                {{item.PAIRING}}
                              </td>
                              <td style="line-height:35px;padding:0px 0px;font-weight:300;" align="center">
                                {{item.CREATING}}
                              </td>
                              <td style="line-height:35px;padding:0px 0px;font-weight:300;" align="center">
                                {{item.COMPLETE}}
                              </td>
                               <td style="line-height:35px;padding:0px 0px;font-weight:300;" align="center">
                                {{item.Overall}}
                              </td>
                            </tr>
                            <tr>
                              <td style="line-height:35px;padding:0px 0px;font-weight:300;" align="center">
                                <div class="left-div-border" :style="{ 'border-left-color': theme }"></div>
                                Team
                              </td>
                              <td style="line-height:35px;padding:0px 0px;font-weight:300;" align="center">
                               {{total.top5.activation}}
                              </td>
                              <td style="line-height:35px;padding:0px 0px;font-weight:300;" align="center">
                               {{total.top5.pairing}}
                              </td>
                              <td style="line-height:35px;padding:0px 0px;font-weight:300;" align="center">
                               {{total.top5.creating}}
                              </td>
                              <td style="line-height:35px;padding:0px 0px;font-weight:300;" align="center">
                               {{total.top5.complete}}
                              </td>
                              <td style="line-height:35px;padding:0px 0px;font-weight:300;" align="center">
                               {{total.top5.overall}}
                              </td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>                    
                </v-container>
            </v-col>
        </v-row>
        <v-divider class="mg-top-0" ></v-divider>
        <v-row justify="space-around" align="center" >
          <v-col cols="12" align="right">
            <v-btn text class="ma-2" :color="theme" @click="seeMoreModalOpen">See More...</v-btn>
          </v-col>
        </v-row>
      </div>         
      <see-more :dialog="seeMoreDialog" 
      :title="title" 
      :closeDialog="seeMoreModalClose" 
      :headers="headers" 
      :DataItems="items"  
      :total="total.all"  
      :theme="theme"
      type="duration"
      />  
  </div>
</template>
<script>
import seeMore from '../DashboardComponents/SeeMoreModal.vue'
export default {
  name: 'DurationStage',
  // props: ['title', 'theme', 'AvgBlock', 'items', 'fields', 'filters', 'seeMoreOpen'],
  components: {
    seeMore
  },
  props: {
    title: {type: String},
    theme: {type: String},
    items: {type: Array},
    total: {type: Object},
    filters: {type: Array}
  },
  data: () => ({
    selectedFilter: '',
    itemArray: [],
    seeMoreDialog: false,
    headers: [
      {
        name: 'name',
        header: 'Name',
        type: 'string',
        format: ['single']
      },
      {
        name: 'ACTIVATION',
        header: 'Activation',
        type: 'string',
        format: ['single']
      },
      {
        name: 'PAIRING',
        header: 'Pairing',
        type: 'string',
        format: ['single']
      },
      {
        name: 'CREATING',
        header: 'CO-Creating',
        type: 'string',
        format: ['single']
      },
      {
        name: 'COMPLETE',
        header: 'Completion',
        type: 'string',
        format: ['single']
      },
      {
        name: 'Overall',
        header: 'Overall Average',
        type: 'string',
        format: ['single']
      }
    ]
    // totalActivation: 0,
    // totalPairing: 0,
    // totalCreating: 0,
    // totalCompletion: 0,
    // teamOverallAverage: 0
  }),
  computed: {
    top5Rows() {
      return this.items.slice(0, 6)
    }
  },
  mounted() {
    this.itemArray = Object.assign([], this.items.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1))
    // this.calcTeam()
  },
  methods: {
    selectedChangeHandler() {
      if (this.selectedFilter === 3) {
        this.items = this.itemArray
      } else {
        this.items = this.itemArray.filter(item => item.id === this.selectedFilter)
      }
    },
    seeMoreModalOpen() {
      this.seeMoreDialog = true
    },
    seeMoreModalClose() {
      this.seeMoreDialog = false
    }
    // calcTeam() {
    //   console.log(this.top5Rows)
    //   this.top5Rows.map(item => {
    //     console.log(item.ACTIVATION)
    //     this.totalActivation += item.ACTIVATION
    //     this.totalPairing += item.PAIRING
    //     this.totalCreating += item.CREATING
    //     this.totalCompletion += item.COMPLETE
    //   })

    //   this.teamOverallAverage = (this.totalActivation + this.totalPairing + this.totalCreating + this.totalCompletion) / 4
    // }
  }
}
</script>
<style scoped>
.mg-top-0 {
  margin-top: 0px !important;
}

.mg-bottom-0 {
  margin-bottom: 0px !important;
}

.mg-bottom-10 {
  margin-bottom: 10px !important;
}

.pd-bottom-0 {
  padding-bottom: 0px !important;
}

.pd-top-0 {
  padding-top: 0px !important;
}

#box {
  /* width: 366px; */
  /* min-height: 430px; */

  border: 0.8px solid #E5E5E5;
  box-sizing: border-box;
}

#title {
  /* width: 366px; */
  height: 46px;

  font-family: WorkSans-Medium;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 45px;
  
  padding-left:17px;
  padding-top:5px;
}

#avg {
  padding-top:10px;
  /* height: 28px; */
  left: calc(50% - 304px/2 - 1px);
  top: calc(50% - 28px/2 - 7.5px);

  font-family: WorkSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  letter-spacing: -0.02em;

  color: #000000;
}

#avgTitle {
  /* width: 309px; */
  height: 12px;
  left: calc(50% - 309px/2 - 3.5px);
  top: calc(50% - 12px/2 + 18.5px);
  padding-top:5px;

  font-family: WorkSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
/* identical to box height */

  text-align: center;
  letter-spacing: -0.02em;

  color: #000000;
}

.left-div-border {
  border-left: 4px solid;
  height: 35px;
  width: 4px;
  float: left;
}

</style>



// WEBPACK FOOTER //
// DurationStage.vue?2930f917